
import React, { Component } from 'react'
import { development, CURRENCY, Modules } from '../../libs/utils/Const';
import { TryMap, ListDocsDeliveries, TransferRouteModal, PolygonMap } from '../index';
import $ from 'jquery';
import Select from 'react-select';
import { Envasados, Granel } from '../../libs/utils/Const';
const mapStatus = {
    'Delivered': 'Finalizado',
    'Charged': 'Cargado',
    'Assigned': 'Asignado',
    'Canceled': 'Cancelado'
}

const quantityItem = (line) => {
    let quantity = 0.00;
    let unitMsr = line?.SalUnitMsr ?? '';

    if (line.U_RS_UMED === 'GLN') {
        quantity = Number(line?.U_RS_CANTG ?? 0).toFixed(3);
    } else {
        quantity = Number(line?.Quantity ?? 0).toFixed(3);
    }

    if (Granel.includes(Number(line?.ItmsGrpCod ?? -1))) {
        unitMsr = line?.U_RS_UMED ?? '';
    }

    return `${quantity} ${unitMsr}`;
};

class DocDelivery extends Component {
    constructor(props) {
        super(props)
        this.state = {
            editMode: false,
            recoveryModel: null,
            tabActive: 0,
            showTransferRouteModal: false,
        }
    }

    ChangeEditMode = () => {
        const { RouteDoc } = this.props
        this.setState({
            editMode: !this.state.editMode,
            recoveryModel: JSON.parse(JSON.stringify(RouteDoc))
        });
    }

    RefreshModel = async (RouteDoc) => {
        const { RefreshRouteDoc } = this.props
        await RefreshRouteDoc(RouteDoc);
    }

    ChangeRouteFieldDoc = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.IdRoute = value;
        this.RefreshModel(RouteDoc)
    }

    ChangeOrderDateInit = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.InitialDate = value;
        RouteDoc.FinalDate = value;
        this.RefreshModel(RouteDoc);
    }

    OnchangeDriver = async (index) => {
        const { RouteDoc, Drivers } = this.props
        const indexNumber = Number(index);
        if (indexNumber === -1) {
            RouteDoc.IdVDRV = '';
            RouteDoc.NameDriver = '';
            RouteDoc.AuxIndexDriver = indexNumber;
            await this.RefreshModel(RouteDoc);
        } else {
            RouteDoc.IdVDRV = Drivers[index].value;
            RouteDoc.NameDriver = Drivers[index].label;
            RouteDoc.AuxIndexDriver = index;
            await this.RefreshModel(RouteDoc);
        }

    }

    OnchangeVehicle = (value) => {
        const { RouteDoc, Drivers, showAlert, Vehicles } = this.props
        RouteDoc.CodigoAutotransporte = value?.value ?? null;
        RouteDoc.pk_Sucursal = value?.pk_Sucursal ?? null;
        this.RefreshModel(RouteDoc);
        if (value) {
            const idxFigTransp = Drivers?.findIndex(driver => Number(driver?.value ?? -2) === Number(value?.U_FMB_Driver ?? -1));
            this.OnchangeDriver(idxFigTransp)
            if (idxFigTransp === -1) {
                showAlert({ type: 'error', message: "Este transporte no tiene una figura de transporte relacionada" });
            }
        } else {
            this.OnchangeDriver(-1)
        }
    }



    RemoveDeliveryRouteDoc = (target) => {
        const { RouteDoc } = this.props
        let auxArray = RouteDoc.DocsLines;
        auxArray.splice(target, 1); // 1 es la cantidad de elemento a eliminar
        RouteDoc.DocsLines = auxArray;
        RouteDoc.NumMerch = auxArray?.length ?? 0;
        this.RefreshModel(RouteDoc);
    }

    CloseModal = () => {
        const { CloseModalActions } = this.props
        this.CancelEditMode();
        CloseModalActions();
    }

    ValidateModel = (RouteDoc, attentionType = '') => {
        const { showAlert, U_FMB_AttentionType2 } = this.props;
        const AttentionType = RouteDoc?.AttentionType || U_FMB_AttentionType2;

        if (RouteDoc.DocsLines.length === 0) {
            showAlert({ type: 'error', message: "AUN NO HAS AGREGADO LINEAS PARA ENTREGAR, AGREGA ENTREGAS PARA CONTINUAR " });
            return false;
        }
        if ((RouteDoc.CodigoAutotransporte === '' || RouteDoc.CodigoAutotransporte === -1) && (attentionType === 'RUT' || (AttentionType !== 'RUT' && !attentionType))) {
            showAlert({ type: 'error', message: "DEBE DE SELECCIONAR UN TRASPORTE PARA CONTINUAR" });
            return false;
        }
        if ((RouteDoc.AuxIndexDriver === '' || RouteDoc.AuxIndexDriver === -1) && (attentionType === 'RUT' || (AttentionType !== 'RUT' && !attentionType))) {
            showAlert({ type: 'error', message: "AUN NO HA SELECCIONADO UN CHOFER" });
            return false;
        }
        // if (RouteDoc.IdRoute === '') {
        //     showAlert({ type: 'error', message: "AUN NO HA SELECCIONADO UNA RUTA" });
        //     return false;
        // }
        if (!AttentionType) {
            showAlert({ type: 'error', message: "AUN NO HA SELECCIONADO EL TIPO DE ATENCIÓN" });
            return false;
        }

        return true
    }

    SendModel = () => {
        const { SendModel, RouteDoc } = this.props
        if (this.ValidateModel(RouteDoc)) SendModel();

    }

    AddDocDelivery = () => {
        const { U_FMB_AttentionType2, showAlert, RouteDoc } = this.props;
        const AttentionType = RouteDoc?.AttentionType || U_FMB_AttentionType2;
        if (!AttentionType) {
            showAlert({ type: 'warning', message: "AUN NO HA SELECCIONADO EL TIPO DE ATENCIÓN" });
            return false;
        }
        this.props.OpenAvailableManualLines();
    }

    CleanDataListDocsDeliveries = () => {
        const { ChangeAnyPropInState, State } = this.props
        // ChangeAnyPropInState('ActualRoutes',[])
        State.ActualRoutes = [];
        ChangeAnyPropInState(State)
    }

    ChangePriorityLine = (value, indexLine) => {
        const { RouteDoc } = this.props
        RouteDoc.DocsLines[indexLine].Priority = Number(value);
        const affectKey = `${RouteDoc.DocsLines[indexLine].ShipToCode},${RouteDoc.DocsLines[indexLine].CardCode}`
        this.RefreshModel(RouteDoc);
        this.props.AffectLinesByKey(affectKey, Number(value))
    }

    AcceptEditMode = async (attentionType = '') => {
        const { acceptEditMode, RouteDoc, U_FMB_AttentionType2 } = this.props;
        if (this.ValidateModel(RouteDoc, attentionType)) {
            RouteDoc.U_FMB_AttentionType = U_FMB_AttentionType2;
            if (attentionType === 'RUT') {
                RouteDoc.CreateRUT = true;
                await this.RefreshModel(RouteDoc);
            } else {
                RouteDoc.CreateRUT = false;
                await this.RefreshModel(RouteDoc);
            }
            acceptEditMode(RouteDoc);
        }
    }

    CancelEditMode = () => {
        const { recoveryModel } = this.state;
        this.RefreshModel(recoveryModel);
        this.setState({
            editMode: false,
            recoveryModel: null,
            showTransferRouteModal: false,
        });
    }
    transferRoute = async () => {
        const { RouteDoc } = this.props
        // RouteDoc.CodigoAutotransporteTransfer = null;
        // RouteDoc.IdVDRVTransfer = '';
        // RouteDoc.NameDriverTransfer = '';
        // RouteDoc.AuxIndexDriverTransfer = -1;
        this.RefreshModel(RouteDoc)

        this.setState({
            showTransferRouteModal: true
        }, () => {
            $("#TransferRouteModal").modal("show");
        })

    }

    validateAttentionType = () => {
        const { action, U_FMB_AttentionType2, RouteDoc } = this.props;
        const { editMode } = this.state;

        let status = (action === 2) && !editMode ? true : false;
        if (action === 1 && U_FMB_AttentionType2 && RouteDoc?.DocsLines?.length) {
            status = true;
        }

        if (action === 2 && editMode && RouteDoc?.AttentionType) {
            status = true;
        }

        return status;
    }

    render() {
        const { action, showAlert, State, Vehicles, RouteDoc, U_FMB_AttentionType2, Drivers } = this.props
        const { editMode } = this.state;
        const AttentionType = RouteDoc?.AttentionType || U_FMB_AttentionType2;
        return (
            <div className="modal fade bd-example-modal-xl modal-open scroll" id="NewDocDelivery20" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">

                {State.MountListAvailableLines &&

                    <ListDocsDeliveries
                        data={this.props.AvailableDeliveryLines}
                        selectItems={this.props.ActionLinesChoose}
                        showAlert={showAlert}
                        search={() => { }}
                        cleanData={this.props.CloseActionListDocsDeliveries}
                        selectItemsToArray={this.props.ChargeLinesManualToDeliveryDoc}
                    />
                }
                {
                    this.state.showTransferRouteModal &&
                    <TransferRouteModal
                        Vehicles={Vehicles}
                        RouteDoc={RouteDoc}
                        RefreshModel={this.RefreshModel}
                        showAlert={showAlert}
                        SendModel={this.SendModel}
                        Drivers={Drivers}
                    />

                }


                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">ENTREGA DE MERCANCIAS</h4>
                            <button type="button" className="close" onClick={() => this.CloseModal()} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                {/* {this.renderSelector()} */}
                                                {this.RenderEditButton()}
                                                {this.RenderHeader()}
                                                {this.RenderBody()}
                                                <br></br>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            {action === 2 && !editMode &&
                                <button type="button" className="btn thirdBtn" onClick={() => this.transferRoute()}>
                                    Transferir Ruta
                                </button>
                            }
                            <button type="button" className="btn botonCerrar text-white" onClick={() => this.CloseModal()}>
                                Cerrar
                            </button>
                            {action === 1 &&
                                <button type="button" className="btn botonCorrect text-black" disabled={this.props?.disableButton}
                                    onClick={() => this.SendModel()}> Crear</button>
                            }

                            {action === 2 && editMode && (
                                <>

                                    {AttentionType === 'RUT' && !RouteDoc.Status &&
                                        <button type="button" className="btn thirdBtn" onClick={() => this.AcceptEditMode('RUT')}>
                                            Activar
                                        </button>
                                    }
                                    <button type="button" className="btn botonCorrect" onClick={() => this.AcceptEditMode()}>
                                        Guardar
                                    </button>

                                    <button type="button" className="btn botonCorrect" onClick={() => this.CancelEditMode()}>
                                        Cancelar
                                    </button>
                                </>
                            )}
                        </div>
                    </div>


                </div>

            </div>

        )
    }

    RenderEditButton() {
        const { GenerateRouteDocByIA, action, RouteDoc } = this.props
        const { editMode } = this.state
        return (
            <>
                {action === 2 && !editMode && (RouteDoc?.TransferRoute ?? null) === null &&
                    <button
                        type="button"
                        style={{ backgroundColor: 'transparent', color: '#000' }}
                        className="btn btn-editar"
                        onClick={() => this.ChangeEditMode()}>
                        <i className="fas fa-edit  fa-lg" />
                        Editar
                    </button>
                }

                {action === 1 && Modules['generateRouteBot'] &&
                    <button
                        type="button"
                        style={{ backgroundColor: 'transparent', color: '#000' }}
                        className="btn"
                        onClick={() => GenerateRouteDocByIA()}>
                        <i className="fab fa-android mr-2" />
                        {`GENERAR RUTA POR ${development ? 'IA' : 'IA'}`}
                    </button>

                }
            </>
        );
    }

    RenderHeader = () => {
        const { editMode } = this.state
        const { RouteDoc, Drivers, Vehicles, action, ChangeAttentionType, U_FMB_AttentionType2 } = this.props;
        return (
            <>
                <h4>Datos generales {(RouteDoc?.TransferRoute ?? null) != null ? `(Transferido a ${RouteDoc.TransferRoute})` : ''}</h4>
                <div className="row">
                    {/*PRIMER COLUMNA */}
                    <div className="col-12 col-md-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" id="txtPartner">Código</span>
                            </div>
                            <input type="text" className="form-control"
                                id="txtCardCode"
                                disabled={true}
                                value={RouteDoc?.Code ?? ""}
                            />
                        </div>
                        {/* <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Poligono </span>
                            </div>
                            <select
                                id="codeDeliveryRoute"
                                className="form-control"
                                value={RouteDoc?.IdRoute ?? ""}
                                onChange={(event) => this.ChangeRouteFieldDoc(event.target.value)}
                                // disabled={true}
                                disabled={(action === 2) && !editMode ? true : false}
                            >
                                <option value=''>Seleccione un poligono</option>
                                {ActualRoutes && ActualRoutes.length > 0 &&
                                    ActualRoutes.map((element) => {
                                        return (
                                            <option value={element?.DocEntry}>{element?.codigo ?? ''}</option>
                                        )
                                    })
                                }
                            </select>
                        </div> */}

                        {/* FECHA DE ENTREGA */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Fecha</span>
                            </div>
                            <input
                                type="date"
                                className="form-control"
                                value={RouteDoc ? RouteDoc.InitialDate : ''}
                                disabled={(action === 2) && !editMode ? true : false}
                                onChange={(event) => this.ChangeOrderDateInit(event.target.value)}
                            />

                        </div>

                        {/* NUMERO DE MERCANCIAS */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">No. Mercancias</span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                value={RouteDoc ? RouteDoc.NumMerch : ''}
                                disabled={true}
                            />
                            <button type="button"
                                className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                onClick={() => this.GuideUser('MerchNum')}>
                                <i className="fa fa-info-circle" />
                            </button>
                        </div>

                        {/* PESO TOTAL POR LAS LINEAS */}
                        {/* <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Peso por mercancías</span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                value={RouteDoc ? RouteDoc.WeightCharged : ''}
                                disabled={true}
                            />
                            <button type="button"
                                className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                onClick={() => this.GuideUser('WeightCharged')}>
                                <i className="fa fa-info-circle" />
                            </button>
                        </div> */}

                    </div>

                    {/*SEGUNDA COLUMNA CARTA PORTE*/}
                    <div className="col-12 col-md-6">
                        {/*Chofer*/}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Chofer</span>
                            </div>
                            <Select
                                options={Drivers ?? []}
                                value={Drivers?.find(opt => opt.value === RouteDoc?.IdVDRV ?? '') || null}
                                onChange={this.changeChofer}
                                placeholder="Escribe para buscar chofer"
                                isDisabled={true}
                                isSearchable={true}
                                isClearable={true}
                                menuPortalTarget={document.body}
                                noOptionsMessage={() => 'No se encontraron coincidencias'}
                                styles={{
                                    container: (base) => ({ ...base, flex: 1 }),
                                    control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                    input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                    singleValue: (base) => ({ ...base, color: "#000" })
                                }}
                            />
                        </div>
                        {/* Chofer */}
                        {/* <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" >Chofer</span>
                            </div>
                            <input type="text" className="form-control"
                                id="txtChofer"
                                disabled={true}
                                value={RouteDoc?.NameDriver ?? ''}
                            /> */}
                        {/* <select className="form-control"
                                // onChange={(event) => this.OnchangeDriver(event.target.value)}
                                value={RouteDoc ? RouteDoc.AuxIndexDriver : ''}
                                // disabled={(action === 2) && !editMode ? true : false}
                                disabled={true}
                            >
                                <option value={-1}>Seleccione el chofer responsable</option>
                                {Drivers && Drivers.map((driver, index) => {
                                    return (
                                        <option value={index}>
                                            {driver?.NombreFigura ?? ""}.  -  {changeTipoFigura((driver?.TipoFigura ?? "").trim() ?? '')}
                                        </option>
                                    );
                                })}

                            </select> */}
                        {/* </div> */}
                        {/*VEHICULO*/}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Vehículo</span>
                            </div>
                            <Select
                                options={Vehicles ?? []}
                                value={Vehicles?.find(opt => opt.value === RouteDoc?.CodigoAutotransporte ?? '') || null}
                                onChange={this.OnchangeVehicle}
                                placeholder="Escribe para buscar vehiculo"
                                isDisabled={(action === 2) && !editMode ? true : false}
                                isSearchable={true}
                                isClearable={true}
                                menuPortalTarget={document.body}
                                noOptionsMessage={() => 'No se encontraron coincidencias'}
                                styles={{
                                    container: (base) => ({ ...base, flex: 1 }),
                                    control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                    input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                    singleValue: (base) => ({ ...base, color: "#000" })
                                }}
                            />
                        </div>
                        {/* <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Vehículo</span>
                            </div>
                            <select
                                className="form-control"
                                onChange={(event) => this.OnchangeVehicle(event.target.value)}
                                value={RouteDoc ? RouteDoc.CodigoAutotransporte : ''}
                                disabled={(action === 2) && !editMode ? true : false}
                            >
                                <option>Seleccione el Vehículo </option>
                                {Vehicles && Vehicles.map((vehicle, index) => {
                                    return (
                                        <option key={index} value={vehicle.CodigoAutotransporte}>
                                            {vehicle.TipodeUnidad} - {vehicle.ConfigVehicular}. Matricula: {vehicle.PlacaVM}
                                        </option>
                                    );
                                })}
                            </select>
                        </div> */}
                        {/* Tipo de atención */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                    <span className="d-none d-xl-inline">Tipo de atención</span>
                                    <span className="d-inline d-xl-none">T. atención</span>
                                </span>
                            </div>
                            <select
                                id="attentionType"
                                className="form-control"
                                onChange={async (event) => {
                                    await ChangeAttentionType(event?.target?.value, 2);
                                }}
                                value={RouteDoc?.AttentionType || (U_FMB_AttentionType2 ?? "")}
                                disabled={this.validateAttentionType()}
                            >
                                <option value="">Seleccionar</option>
                                <option value="RCF">Ruta Cliente Final</option>
                                <option value="RUT">Ruta distribuidores</option>
                            </select>
                        </div>
                        {/* Estatus */}
                        <div className="input-group mb-3">
                            <div className="input-group-prepend ">
                                <span className="input-group-text font-weight-bold" id="txtPartner">Estatus</span>
                            </div>
                            <input type="text" className="form-control"
                                id="txtStatus"
                                disabled={true}
                                value={RouteDoc?.AttentionType === 'RUT' ? RouteDoc?.Status ? 'Activo' : 'Inactivo' : ""}
                            />
                        </div>

                        <div >
                            <div>
                                {/* <label className="btn float-left" onClick={() => this.DownloadDocCartaPorte('PDF')}><i class="fa fa-file-text-o"></i> Descargar PDF Carta Porte</label>
                                <label className="btn float-left" onClick={() => this.DownloadDocCartaPorte('XML')}><i class="fa fa-file-text"></i> Descargar XML Carta Porte</label> */}
                            </div>
                        </div>

                    </div>
                    <br></br>
                </div>
                <br />


            </>
        );

    }

    RenderBody = () => {
        const { RouteDoc, Waypoints, action } = this.props;
        const { tabActive, editMode } = this.state;
        const tabs = [
            { // Mercancias
                title: "Mercancias",
                tab: (
                    <div className="tab-pane active">
                        <div className="w-100 table-scroll tab-pane " style={{ textAlign: 'center' }}>
                            <table id="dataTableDocuments" className="display" style={{ width: '100%', marginBottom: 40, marginRight: -3000, tableLayout: 'auto', maxHeight: '400px', overflowY: 'auto' }}>
                                <thead className="table-header-yellow">
                                    <tr>
                                        <td className="sticky-header1 text-center"> ESTADO </td>
                                        <td className="sticky-header1 text-center"> DOCUMENTO </td>
                                        <td className="sticky-header1 text-center"> CLIENTE </td>
                                        <td className="sticky-header1 text-center"> ID DIRECCION </td>
                                        <td className="sticky-header1 text-center"> DIRECCION </td>
                                        <td className="sticky-header1 text-center"> CANTIDAD </td>
                                        <td className="sticky-header1 text-center"> ARTÍCULO </td>
                                        <td className="sticky-header1 text-center"> DESCRIPCION </td>
                                        <td className="sticky-header1 text-center"> PRIORIDAD </td>
                                        {/* <td className="sticky-header1 text-center"> PRECIO LINEA </td>
                                        <td className="sticky-header1 text-center"> PESO EN KG </td> */}
                                        {!(action === 2 && !editMode) && <td className="sticky-header1 text-center" />}
                                    </tr>
                                </thead>
                                <tbody>
                                    {RouteDoc && RouteDoc.DocsLines && RouteDoc.DocsLines.length > 0 &&
                                        RouteDoc.DocsLines.map((routeLine, indexLine) =>
                                            <tr key={indexLine}>
                                                <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}> {mapStatus[routeLine?.ProcessStatus ?? ''] ?? '-'} </td> {/* ESTATUS DE LINEA */}
                                                <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}> {routeLine?.NumAtCard || routeLine?.DocNum || ""} </td> {/* FOLIO / DOCNUM */}

                                                <td style={{ whiteSpace: 'normal', wordBreak: 'break-word', width: '200px', maxWidth: '200px', minWidth: '200px' }}> {routeLine?.CardName || ""} </td> {/* SOCIO */}
                                                <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}> {routeLine?.ShipToCode || ""} </td> {/* ID DIRECCION */}
                                                <td style={{ whiteSpace: 'normal', wordBreak: 'break-word', width: '250px', maxWidth: '250px', minWidth: '250px' }}> {routeLine?.AddressDesc || ""} </td> {/* DIRECCION */}

                                                {/* <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}> {routeLine.U_RS_TIPOV == 'GRANEL' ? `${Number(routeLine?.U_RS_CANTG || 0).toFixed(3)} ${routeLine?.U_RS_UMED ?? ''}` : Number(routeLine?.Quantity || 0).toFixed(3)} </td> CANTIDAD */}
                                                <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{quantityItem(routeLine)}</td>
                                                <td style={{ whiteSpace: 'nowrap', wordBreak: 'center' }}> {routeLine?.ItemCode || ""} </td> {/* ARTÍCULO */}
                                                <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}> {routeLine?.ItemName || ""} </td> {/* DESCRIPTION */}
                                                {/* PRIORIDAD DE ENTREGA */}
                                                <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                                                    <select
                                                        className="form-control"
                                                        disabled={action === 2 && !editMode}
                                                        value={routeLine?.Priority ?? 1}
                                                        onChange={(event) => this.ChangePriorityLine(event.target.value, indexLine)}
                                                        style={{
                                                            width: 'auto',
                                                            minWidth: '90px',
                                                            display: 'inline-block'
                                                        }} >
                                                        <option value={3}>ALTA</option>
                                                        <option value={2}>MEDIA</option>
                                                        <option value={1}>BAJA</option>
                                                    </select>
                                                </td>
                                                {/* <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}> {`${CURRENCY} ${Number(routeLine?.LineTotal || 0).toFixed(2)}`} </td>{/* PRECIO DE LINEA*/}
                                                {/* <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}> {Number(routeLine?.TotalWeightLine || 0).toFixed(3)} </td>{/*  PESO TOTAL EN KG */}
                                                {!(action === 2 && !editMode) &&
                                                    <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-danger"
                                                            disabled={action === 2 && !editMode}
                                                            onClick={() => this.RemoveDeliveryRouteDoc(indexLine)} >
                                                            <i className="fas fa-trash-alt" />
                                                        </button>
                                                    </td>
                                                }
                                            </tr>
                                        )
                                    }

                                    {!(action === 2 && !editMode) &&
                                        <tr>
                                            <td className="sticky-column text-center">
                                                <button type="button" className="btn btn-outline-success border-0" onClick={this.AddDocDelivery}> <i className="fa fa-plus-circle" /> </button>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                )
            },
            { // Mapa
                title: "Mapa",
                tab: (
                    <div className="tab-pane active">
                        <div className="col-12 col-xl-8 activeRoute mx-auto" style={{ width: '100%', height: '50vh', position: 'relative', zIndex: 0 }}>
                            <PolygonMap
                                polygons={RouteDoc?.Polygon || []}
                                deliveryLocations={Waypoints}
                                localizations={RouteDoc?.localizations || []}
                            />
                            {/* <TryMap waypoints={Waypoints} /> */}
                        </div>
                    </div>
                )
            }
        ];

        return (
            <div>
                <nav>
                    <div className="nav nav-tabs">
                        {tabs.map((cTab, index) => <a className={`nav-item nav-link font-weight-bold text-secondary ${index === tabActive ? 'active' : ''}`} style={{ cursor: "pointer" }} onClick={() => this.setState({ tabActive: index })}> {cTab.title} </a>)}
                    </div>
                </nav>
                <div className="tab-content border border-top-0 rounded-bottom">
                    {tabs.map((cTab, index) => index === tabActive && cTab.tab)}
                </div>
            </div>
        );
    }

    GuideUser = (buttonIdentifier) => {
        const { showAlert } = this.props;

        switch (buttonIdentifier) {
            case 'MerchNum':
                showAlert({ type: 'info', message: 'NUMERO DE MERCANCIAS EN EL DOCUMENTO DE ENTREGA', timeOut: 4000 });
                break;
            case 'WeightCharged':
                showAlert({ type: 'info', message: 'PESO EN KG EN LA UNIDAD', timeOut: 4000 });
                break;

            default:
                break;
        }

    }


}

export default DocDelivery